import React, { useEffect, useState } from "react";
import AmCharts from "@amcharts/amcharts3-react";
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'antd';
import { RollbackOutlined } from '@ant-design/icons';
import RequestHandler from "../../util/RequestHandler";

const FirmStatusReportChart = (props) => {
  const history = useHistory();
  const paymentChartListbefore = [];
  const [paymentChartList, setPaymentChartList] = useState([]);

  useEffect(() => {
    RequestHandler.post(`/Reports`, {
      firmId: props.match.params.firmId === 'null' ? null : props.match.params.firmId,
      collectPlanTotal: props.match.params.CollectPlanTotal === '0' ? 0 : props.match.params.CollectPlanTotal,
      collectPlanTotal2: props.match.params.CollectPlanTotal2 === '0' ? 0 : props.match.params.CollectPlanTotal2,
      collectTotal: props.match.params.CollectTotal === '0' ? 0 : props.match.params.CollectTotal,
      collectTotal2: props.match.params.CollectTotal2 === '0' ? 0 : props.match.params.CollectTotal2,
      paymentPlanTotal: props.match.params.PaymentPlanTotal === '0' ? 0 : props.match.params.PaymentPlanTotal,
      paymentPlanTotal2: props.match.params.PaymentPlanTotal2 === '0' ? 0 : props.match.params.PaymentPlanTotal2,
      paymentTotal: props.match.params.PaymentTotal === '0' ? 0 : props.match.params.PaymentTotal,
      paymentTotal2: props.match.params.PaymentTotal2 === '0' ? 0 : props.match.params.PaymentTotal2,
      currencyCode: props.match.params.CurrencyCode === 'null' ? null : props.match.params.CurrencyCode,
      date: props.match.params.Date === 'undefined' ? null : props.match.params.Date,
      endDate: props.match.params.Date2 === 'undefined' ? null : props.match.params.Date2
    }, false).then(response => {
      response.value.map((item) => {
        const newObject = {
          FirmId: item.firmId,
          PaymentTotal: item.paymentTotal,
        };
        paymentChartListbefore.push(newObject);
      });
      setPaymentChartList(paymentChartListbefore);
    });
  }, [])

  const config = {
    "type": "pie",
    "theme": "light",
    "dataProvider": paymentChartList,
    "valueField": "PaymentTotal",
    "titleField": "FirmId",
    "balloon": {
      "fixedPosition": true
    },
    "export": {
      "enabled": false

    }
  };

  return (
    <div className="App">
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}><a onClick={() => history.goBack()} style={{ color: 'black', marginLeft: "4%" }}> <RollbackOutlined /> GERİ DÖN</a></Col>
        <Col flex={4}></Col>
      </Row>
      <AmCharts.React style={{ width: "100%", height: "500px" }} options={config} />
      <Row>
        <Col flex={3}></Col>
        <Col flex={3}><p style={{ fontSize: '200%' }}>GERÇEKLEŞEN ÖDEME</p><br></br></Col>
      </Row>

    </div>
  )
}

export default FirmStatusReportChart;
